import { format } from "date-fns";
import { Button } from "primereact/button";
import { dashboardBodyTemplate } from "../../utils/problemTemplates";
import { hasProblemImage } from "../../utils/problemImage";

const Label = ({ children }) => (
  <span className="text-xs font-bold uppercase text-slate-400">{children}</span>
);

// "DESKRIPSI" column (mobile): the whole problem in one cell, every info with its own look, and its buttons
//   formatLabelGrup: label_grup as text (of the variant)
const ProblemDescriptionMobile = ({
  rowData,
  formatLabelGrup,
  onDelete,
  onEdit,
  onClickImage,
  onClickShowPengecekan,
}) => {
  const { tanggal_selesai, data_kendaraan, data_trailer, data_di_tangani } =
    rowData;

  const dayCountToToday = Math.floor(
    (new Date() - new Date(rowData?.tanggal)) / (1000 * 60 * 60 * 24)
  );

  const groupText =
    rowData?.label_grup && rowData?.label_grup.length > 0
      ? formatLabelGrup(rowData.label_grup)
      : "";

  return (
    <>
      <div className="col-start-start w-full px-3 py-3 gap-3">
        {/* Who: the kendaraan / trailer, and when */}
        <div className="col-start-start gap-1">
          {data_trailer && (
            <span className="text-base font-bold">
              {data_trailer?.nomor} - TRAILER
            </span>
          )}
          {data_kendaraan && (
            <span className="text-base font-bold">
              {data_kendaraan?.nomor_polisi} - {data_kendaraan?.jenis_mobil}
            </span>
          )}
          {rowData?.tanggal && (
            <div className="row-start-center gap-2 flex-wrap">
              <span className="text-xs font-semibold text-slate-500">
                {format(new Date(rowData?.tanggal), "dd/MM/yyyy")}
              </span>
              {tanggal_selesai && (
                <>
                  <span className="text-xs text-slate-400">s/d</span>
                  <span className="text-xs font-semibold text-green-600">
                    {format(new Date(rowData?.tanggal_selesai), "dd/MM/yyyy")}
                  </span>
                </>
              )}
              {dayCountToToday > 0 && (
                <span className="rounded-full bg-slate-200 px-2 py-0.5 text-xs font-semibold text-slate-600">
                  {dayCountToToday} hari
                </span>
              )}
            </div>
          )}
        </div>

        {/* What: group and keterangan */}
        <div className="col-start-start gap-1 w-full rounded-md bg-white/70 border border-slate-200 px-2 py-2">
          <div className="col-start-start">
            <Label>Group</Label>
            <span className="text-sm text-slate-600">{groupText || "-"}</span>
          </div>
          <div className="col-start-start">
            <Label>Keterangan</Label>
            <span className="text-base leading-snug">
              {rowData?.keterangan || "-"}
            </span>
          </div>
        </div>

        {/* Dashboard */}
        <div className="col-start-start gap-1">
          <Label>Dashboard</Label>
          {dashboardBodyTemplate(rowData)}
        </div>

        {/* Note */}
        {rowData?.note && (
          <div className="col-start-start w-full rounded-md border-l-4 border-amber-300 bg-amber-50 px-2 py-1">
            <Label>Note</Label>
            <span className="text-sm italic text-slate-600">
              {rowData?.note}
            </span>
          </div>
        )}

        {/* Ditangani */}
        {data_di_tangani && (
          <div className="col-start-start">
            <Label>Ditangani</Label>
            <span className="text-sm font-semibold">
              {data_di_tangani.nama}
            </span>
            <span className="text-xs text-slate-500">
              {rowData?.di_tangani_datetime
                ? format(new Date(rowData?.di_tangani_datetime), "dd/MM/yyyy")
                : "?"}
            </span>
          </div>
        )}

        <div className="gap-2 w-full grid grid-cols-2">
          <Button
            icon="pi pi-trash"
            label="Delete"
            text
            severity="danger"
            className="!py-1 !px-2 !bg-white !border !border-slate-200"
            onClick={() => onDelete(rowData)}
          />
          {hasProblemImage(rowData) && (
            <Button
              icon="pi pi-image"
              label="Foto"
              text
              className="!py-1 !px-2 !bg-white !border !border-slate-200"
              onClick={() => onClickImage(rowData)}
            />
          )}
          <Button
            icon="pi pi-pencil"
            label="Edit"
            text
            severity="success"
            className="!py-1 !px-2 !bg-white !border !border-slate-200"
            onClick={() => onEdit(rowData)}
          />

          <Button
            icon="pi pi-eye"
            label="Lihat Cek"
            text
            className="!py-1 !px-2 !bg-white !border !border-slate-200"
            onClick={() => onClickShowPengecekan(rowData)}
          />
        </div>
      </div>
    </>
  );
};

export default ProblemDescriptionMobile;
